import React from 'react';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { LocaleContext } from '../contexts/language';
import PropTypes from 'prop-types';
import ar from './ar.json';
import en from './en.json';
import TuneIcon from '@mui/icons-material/Tune';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

import TabletMacIcon from '@mui/icons-material/TabletMac';
import SpeedIcon from '@mui/icons-material/Speed';
import PowerIcon from '@mui/icons-material/Power';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AirlineSeatReclineExtraIcon from '@mui/icons-material/AirlineSeatReclineExtra';
import SensorsIcon from '@mui/icons-material/Sensors';
import StarHalfIcon from '@mui/icons-material/StarHalf';
const languages = {
  ar, en
};


export const MessageWrapper = ({ children }) => {
  const localeConfig = React.useContext(LocaleContext);
  return (<IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}>
    {children}
  </IntlProvider>);
};
MessageWrapper.propTypes = {
  children: PropTypes.node
};

const FIELD_CONFIG = [{
  'slug': 'basics',
  'details_open': true,
  'details_show': true,
  'compare_show': true,
  'icon': <TuneIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
    defaultMessage={'The Basics'} /></MessageWrapper>,
  'search_open': true,
  'search_show': true,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
      defaultMessage={'The Basics'} /></MessageWrapper>,
    'details_show': false,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.showMe'}
      defaultMessage={'Show Me'} /></MessageWrapper>,
    'path': 'offer_type',
    'search_show': true,
    'slug': 'offer_type',
    'type': 'term',
    'compare_show':false
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
      defaultMessage={'The Basics'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.price'}
      defaultMessage={'Price'} /></MessageWrapper>,
    'path': 'purchase_amount',
    'reverse': false,
    'search_show': true,
    'slug': 'purchase_amount',
    'step': 1000,
    'type': 'float',
    'unit': 'currency'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
      defaultMessage={'The Basics'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'path': 'monthly_amount',
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.monthlyPrice'}
      defaultMessage={'Monthly Payment'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'monthly_amount',
    'step': 500,
    'type': 'float',
    'unit': 'currency'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
      defaultMessage={'The Basics'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.carShape'}
      defaultMessage={'Car Shape'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'car_shapes',
    'type': 'names',
    'model': 'allDriveNinjaCarShapeType'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
      defaultMessage={'The Basics'} /></MessageWrapper>,
    'details_show': false,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.imLookingFora'}
      defaultMessage={'I\'m looking for a\u2026'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'car_shapes',
    'type': 'names',
    'model': 'allDriveNinjaCarShapeType'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
      defaultMessage={'The Basics'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.carType'}
      defaultMessage={'Car Type'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'car_types',
    'type': 'names',
    'model': 'allDriveNinjaCarTypeType'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
      defaultMessage={'The Basics'} /></MessageWrapper>,
    'details_show': false,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.andItMustBe'}
      defaultMessage={'\u2026and it must be'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'car_types',
    'type': 'names',
    'model': 'allDriveNinjaCarTypeType'
  }, // {
  //   'category':<MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'} defaultMessage={'The Basics'}/></MessageWrapper>,
  //   'details_show': true,'compare_show':true,
  //   'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.lifestyle'} defaultMessage={'Lifestyle'}/></MessageWrapper>,
  //   'reverse': false,
  //   'search_show': true,
  //   'slug': 'lifestyles',
  //   'type': 'names',
  //   'model': 'allDriveNinjaLifeStyleType',
  // },
  {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
      defaultMessage={'The Basics'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': false,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.availability'}
      defaultMessage={'Availability'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'stock_availability',
    'type': 'term'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
      defaultMessage={'The Basics'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.numberOfSeats'}
      defaultMessage={'Number Of Seats'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'num_seats',
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
      defaultMessage={'The Basics'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.modelYear'}
      defaultMessage={'Model Year'} /></MessageWrapper>,
    'reverse': true,
    'search_show': true,
    'slug': 'model_year',
    'type': 'term',
    'model': 'allDriveNinjaTrimLevelType'

  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.theBasics'}
      defaultMessage={'The Basics'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': false,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.Mileage'}
      defaultMessage={'Mileage'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'mileage_km',
    'type': 'int',
    'unit': 'Km'
  }]
}, {
  'slug': 'make-model',
  'details_open': false,
  'details_show': false,
  'icon': <DirectionsCarIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.makeModel'}
    defaultMessage={'Make & Model'} /></MessageWrapper>,
  'search_open': false, 'compare_open': false,
  'search_show': true,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.makeModel'}
      defaultMessage={'Make & Model'} /></MessageWrapper>,
    'details_show': false,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.make'}
      defaultMessage={'Make'} /></MessageWrapper>,
    'path': 'trim_level.sub_model.model.manufacturer.slug_name',
    'queryParam': 'mfr',
    'reverse': false,
    'search_show': true,
    'slug': 'manufacturer',
    'type': 'name'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.makeModel'}
      defaultMessage={'Make & Model'} /></MessageWrapper>,
    'details_show': false,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.model'}
      defaultMessage={'Model'} /></MessageWrapper>,
    'path': 'trim_level.sub_model.model.slug_name',
    'queryParam': 'mdl',
    'reverse': false,
    'search_show': false,
    'slug': 'model',
    'type': 'names',
    'model': 'allDriveNinjaModelType'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.makeModel'}
      defaultMessage={'Make & Model'} /></MessageWrapper>,
    'details_show': false,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.model'}
      defaultMessage={'Model'} /></MessageWrapper>,
    'path': 'trim_level.sub_model.model.slug_name',
    'queryParam': 'mdl',
    'reverse': false,
    'search_show': true,
    'slug': 'model',
    'type': 'name'
  }]
}, {
  'slug': 'popular-features',
  'details_open': false,
  'details_show': true,
  'compare_show': true,
  'icon': <WhatshotIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
    defaultMessage={'Popular Features'} /></MessageWrapper>,
  'search_open': false, 'compare_open': false,
  'search_show': true,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.numberOfDoors'}
      defaultMessage={'Number Of Doors'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'num_doors',
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.leatherSeats'}
      defaultMessage={'Leather Seats'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'leather_seats',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.cruiseControl'}
      defaultMessage={'Cruise Control'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'cruise_control',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.adaptiveCruiseControl'}
      defaultMessage={'Adaptive Cruise Control'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'adaptive_cruise_control',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.frontParkingSensors'}
      defaultMessage={'Front Parking Sensors'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'front_parking_sensors',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.rearParkingSensors'}
      defaultMessage={'Rear Parking Sensors'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'rear_parking_sensors',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.reversingCamera'}
      defaultMessage={'Reversing Camera'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'reversing_camera',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.360DegreeCamera'}
      defaultMessage={'360\u00b0 Camera'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'camera_360',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.wirelessPhoneCharging'}
      defaultMessage={'Wireless Phone Charging'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'wireless_charging',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.sunroof'}
      defaultMessage={'Sunroof'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'sunroof_front',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.panoramicSunroof'}
      defaultMessage={'Panoramic Sunroof'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'panoramic_sunroof',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.remoteVehicleStart'}
      defaultMessage={'Remote Vehicle Start'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'remote_vehicle_start',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.handsFreeTailgate'}
      defaultMessage={'Hands Free Tailgate'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'hands_free_tailgate',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.appleCarPlay'}
      defaultMessage={'Apple CarPlay'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'apple_car_play',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.androidAuto'}
      defaultMessage={'Android Auto'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'android_auto',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.popularFeatures'}
      defaultMessage={'Popular Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.hybridElectric'}
      defaultMessage={'Hybrid/Electric'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'hybrid_fuel_type',
    'type': 'name'
  }]
}, {
  'slug': 'infotainment',
  'details_open': false,
  'details_show': true,
  'compare_show': true,
  'icon': <TabletMacIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
    defaultMessage={'Infotainment'} /></MessageWrapper>,
  'search_open': false, 'compare_open': false,
  'search_show': true,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.bluetooth'}
      defaultMessage={'Bluetooth'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'bluetooth',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.auxInput'}
      defaultMessage={'Auxiliary Input'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'aux_input',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.usbInput'}
      defaultMessage={'USB Input'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'usb_input',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.navigation'}
      defaultMessage={'Navigation'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'navigation',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.numberOfSpeakers'}
      defaultMessage={'Number of Speakers'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'num_speakers',
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.touchscreen'}
      defaultMessage={'Touchscreen'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'touchscreen',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.appleCarPlay'}
      defaultMessage={'Apple CarPlay'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'apple_car_play',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.androidAuto'}
      defaultMessage={'Android Auto'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'android_auto',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.wirelessPhoneCharging'}
      defaultMessage={'Wireless Phone Charging'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'wireless_charging',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.headUpDisplay'}
      defaultMessage={'Head-Up Display (HUD)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'head_up_display',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.voiceControl'}
      defaultMessage={'Voice Control'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'voice_control',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.wifiConnection'}
      defaultMessage={'WiFi Connection'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'wifi_connection',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.infotainment'}
      defaultMessage={'Infotainment'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.soundSystemBrand'}
      defaultMessage={'Sound System Brand'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'sound_system_brand',
    'type': 'name'
  }]
}, {
  'slug': 'interior',
  'details_open': false,
  'details_show': true,
  'compare_show': true,
  'icon':<FactCheckIcon/>,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.interiorFeatures'}
    defaultMessage={'Interior Features'} /></MessageWrapper>,
  'search_open': false, 'compare_open': false,
  'search_show': true,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.interiorFeatures'}
      defaultMessage={'Interior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.rearPassengerACVents'}
      defaultMessage={'Rear Passenger AC Vents'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'rear_passenger_ac_vents',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.interiorFeatures'}
      defaultMessage={'Interior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.automaticAC'}
      defaultMessage={'AutomaticAirConditioning (Climate Control)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'automatic_air_conditioning',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.interiorFeatures'}
      defaultMessage={'Interior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.pushButtonStart'}
      defaultMessage={'Push Button Start'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'push_button_start',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.interiorFeatures'}
      defaultMessage={'Interior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.rearWindscreenShade'}
      defaultMessage={'Rear Windscreen Shade'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'rear_windscreen_shade',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.interiorFeatures'}
      defaultMessage={'Interior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.bootCapacityL'}
      defaultMessage={'Boot Capacity (L)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'boot_capacity',
    'step': 5,
    'type': 'int',
    'unit': 'L'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.interiorFeatures'}
      defaultMessage={'Interior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.leatherSteeringWheel'}
      defaultMessage={'Leather Steering Wheel'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'leather_wrapped_steering_wheel',
    'type': 'bool'
  }]
}, {
  'slug': 'seating',
  'details_open': false,
  'details_show': true,
  'compare_show': true,
  'icon': <AirlineSeatReclineExtraIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.seating'}
    defaultMessage={'Seating'} /></MessageWrapper>,
  'search_open': false, 'compare_open': false,
  'search_show': true,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.seating'}
      defaultMessage={'Seating'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.cooledSeats'}
      defaultMessage={'Cooled Seats'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'cooled_seats',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.seating'}
      defaultMessage={'Seating'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.electricDriverSeat'}
      defaultMessage={'Electric Driver Seat'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'electric_driver_seat',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.seating'}
      defaultMessage={'Seating'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.electricPassengerSeat'}
      defaultMessage={'Electric Passenger Seat'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'electric_passenger_seat',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.seating'}
      defaultMessage={'Seating'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.leatherSeats'}
      defaultMessage={'Leather Seats'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'leather_seats',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.seating'}
      defaultMessage={'Seating'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.isofixChildSeatAttachments'}
      defaultMessage={'ISOFIX Child Seat Attachments'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'isofix_child_seat',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.seating'}
      defaultMessage={'Seating'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.numberOfSeats'}
      defaultMessage={'Number of Seats'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'num_seats',
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.seating'}
      defaultMessage={'Seating'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.splitFoldingRearSeats'}
      defaultMessage={'Split-Folding Rear Seats'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'split_folding_rear_seats',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.seating'}
      defaultMessage={'Seating'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.sportsPerformanceSeats'}
      defaultMessage={'Sports/Performance Seats'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'sports_seats',
    'type': 'bool'
  }]
}, {
  'slug': 'exterior',
  'details_open': false,
  'details_show': true,
  'compare_show': true,
  'icon': <SensorsIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
    defaultMessage={'Exterior Features'} /></MessageWrapper>,
  'search_open': false, 'compare_open': false,
  'search_show': true,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.numberOfDoors'}
      defaultMessage={'Number of Doors'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'num_doors',
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.keylessEntry'}
      defaultMessage={'Keyless Entry'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'keyless_entry',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.electronicWingMirrors'}
      defaultMessage={'Electronic Wing Mirrors'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'electric_wing_mirrors',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.autoFoldingWingMirrors'}
      defaultMessage={'Auto Folding Wing Mirrors'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'automatic_folding_wing_mirrors',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.roofRailsRacks'}
      defaultMessage={'Roof Rails/Racks'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'roof_rack_rails',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.frontFogLights'}
      defaultMessage={'Front Fog Lights'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'front_fog_lights',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.rearFogLights'}
      defaultMessage={'Rear Fog Lights'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'rear_fog_lights',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.laserHeadlights'}
      defaultMessage={'Laser Headlights'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'headlamps_laser',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.ledHeadlights'}
      defaultMessage={'LED Headlights'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'headlamps_led',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.automaticHeadlights'}
      defaultMessage={'Automatic Headlights'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'automatic_headlights',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.frontParkingSensors'}
      defaultMessage={'Front Parking Sensors'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'front_parking_sensors',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.rearParkingSensors'}
      defaultMessage={'Rear Parking Sensors'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'rear_parking_sensors',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.reversingCamera'}
      defaultMessage={'Reversing Camera'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'reversing_camera',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.360DegreeCamera'}
      defaultMessage={'360\u00b0 Camera'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'camera_360',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.handsFreeTailgate'}
      defaultMessage={'Hands-Free Tailgate'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'hands_free_tailgate',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.vehicleLength'}
      defaultMessage={'Vehicle Length'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'dimension_length',
    'type': 'int',
    'unit': 'mm'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.vehicleWidth'}
      defaultMessage={'Vehicle Width'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'dimension_width',
    'type': 'int',
    'unit': 'mm'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.vehicleHeight'}
      defaultMessage={'Vehicle Height'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'dimension_height',
    'type': 'int',
    'unit': 'mm'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.wheelbase'}
      defaultMessage={'Wheelbase'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'wheelbase',
    'type': 'int',
    'unit': 'mm'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.exteriorFeatures'}
      defaultMessage={'Exterior Features'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.wheelSizeInches'}
      defaultMessage={'Wheel Size (Inches)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'wheel_size',
    'type': 'int',
    'unit': '"'
  }]
}, {
  'slug': 'power',
  'details_open': false,
  'details_show': true,
  'compare_show': true,
  'icon': <SpeedIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.powerAndSpeed'}
    defaultMessage={'Power & Speed'} /></MessageWrapper>,
  'search_open': false, 'compare_open': false,
  'search_show': true,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.powerAndSpeed'}
      defaultMessage={'Power & Speed'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.powerHp'}
      defaultMessage={'Power (HP)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'power',
    'step': 10,
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.powerAndSpeed'}
      defaultMessage={'Power & Speed'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.kerbWeightKg'}
      defaultMessage={'Kerb Weight (KG)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'weight',
    'step': 100,
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.powerAndSpeed'}
      defaultMessage={'Power & Speed'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.powerWeightRatio'}
      defaultMessage={'Power To Weight Ratio (HP/Tonne)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'power_to_weight',
    'step': 10,
    'type': 'float'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.powerAndSpeed'}
      defaultMessage={'Power & Speed'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.numberOfCylinders'}
      defaultMessage={'Number of Cylinders'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'num_cylinders',
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.powerAndSpeed'}
      defaultMessage={'Power & Speed'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.engineCapacityL'}
      defaultMessage={'Engine Capacity (L)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'engine_capacity',
    'type': 'float'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.powerAndSpeed'}
      defaultMessage={'Power & Speed'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.0100TimeSeconds'}
      defaultMessage={'0-100 Time (Seconds)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'time_0_100',
    'type': 'float'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.powerAndSpeed'}
      defaultMessage={'Power & Speed'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.topSpeed'}
      defaultMessage={'Top Speed'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'top_speed',
    'step': 10,
    'type': 'int',
    'unit': 'km/h'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.powerAndSpeed'}
      defaultMessage={'Power & Speed'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.torque'}
      defaultMessage={'Torque (Nm)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'torque',
    'step': 10,
    'type': 'int'
  }]
}, {
  'slug': 'electric',
  'details_open': false,
  'details_show': true,
  'compare_show': true,
  'icon': <PowerIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.hybridElectric'}
    defaultMessage={'Hybrid/Electric'} /></MessageWrapper>,
  'search_open': false, 'compare_open': false,
  'search_show': false,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.hybridElectric'}
      defaultMessage={'Hybrid/Electric'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.minimumFullChargeTimeHours'}
      defaultMessage={'Minimum Full Charge Time (Hours)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'charge_time',
    'type': 'float'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.hybridElectric'}
      defaultMessage={'Hybrid/Electric'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.maximumRangeKm'}
      defaultMessage={'Maximum Range (Km)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'range',
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.hybridElectric'}
      defaultMessage={'Hybrid/Electric'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.hybridElectric'}
      defaultMessage={'Hybrid/Electric'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'hybrid_fuel_type',
    'type': 'name'
  }]
}, {
  'slug': 'fuel',
  'details_open': false,
  'details_show': true,
  'compare_show': true,
  'icon': <LocalGasStationIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.fuelGearbox'}
    defaultMessage={'Fuel & Gearbox'} /></MessageWrapper>,
  'search_open': false, 'compare_open': false,
  'search_show': true,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.fuelGearbox'}
      defaultMessage={'Fuel & Gearbox'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.gearbox'}
      defaultMessage={'Gearbox'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'gearbox',
    'type': 'name'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.fuelGearbox'}
      defaultMessage={'Fuel & Gearbox'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.fuelConsumptionL100'}
      defaultMessage={'Fuel Consumption (L/100Km)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'fuel_consumption',
    'type': 'float'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.fuelGearbox'}
      defaultMessage={'Fuel & Gearbox'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.drivingWheels'}
      defaultMessage={'Driving Wheels'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'driving_wheels',
    'type': 'name'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.fuelGearbox'}
      defaultMessage={'Fuel & Gearbox'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.fuelType'}
      defaultMessage={'Fuel Type'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'fuel_type',
    'type': 'name'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.fuelGearbox'}
      defaultMessage={'Fuel & Gearbox'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.fuelTankCapacity'}
      defaultMessage={'Fuel Tank Capacity (L)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'fuel_tank_capacity',
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.fuelGearbox'}
      defaultMessage={'Fuel & Gearbox'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.numberOfGears'}
      defaultMessage={'Number of Gears'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'num_gears',
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.fuelGearbox'}
      defaultMessage={'Fuel & Gearbox'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.paddleShifters'}
      defaultMessage={'Paddle Shifters'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'paddle_shifter',
    'type': 'bool'
  }]
}, {
  'slug': 'safety',
  'details_open': false,
  'details_show': true,
  'compare_show': true,
  'icon': <StarHalfIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
    defaultMessage={'Safety'} /></MessageWrapper>,
  'search_open': false, 'compare_open': false,
  'search_show': true,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.safetyRatingStars'}
      defaultMessage={'Safety Rating (Stars)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'safety_rating',
    'type': 'stars'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.numberOfAirbags'}
      defaultMessage={'Number of Airbags'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'num_airbags',
    'type': 'int'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.adaptiveCruiseControl'}
      defaultMessage={'Adaptive Cruise Control'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'adaptive_cruise_control',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.crashWarningSystem'}
      defaultMessage={'Crash Warning System'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'crash_warning_system',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.blindSpotWarning'}
      defaultMessage={'Blind Spot Warning'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'blind_spot_warning',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.laneDepartureAssist'}
      defaultMessage={'Lane Departure Assist'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'lane_departure_assist',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.isofixChildSeatAttachments'}
      defaultMessage={'ISOFIX Child Seat Attachments'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'isofix_child_seat',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.frontParkingSensors'}
      defaultMessage={'Front Parking Sensors'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'front_parking_sensors',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.rearParkingSensors'}
      defaultMessage={'Rear Parking Sensors'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'rear_parking_sensors',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.reversingCamera'}
      defaultMessage={'Reversing Camera'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'reversing_camera',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.360DegreeCamera'}
      defaultMessage={'360\u00b0 Camera'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'camera_360',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.hillDescentAssist'}
      defaultMessage={'Hill Descent Assist'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'hill_descent_assist',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.hillStartAssist'}
      defaultMessage={'Hill Start Assist'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'hill_start_assist',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.automaticHeadlights'}
      defaultMessage={'Automatic Headlights'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'automatic_headlights',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.daytimeRunningLightsDRL'}
      defaultMessage={'Daytime Running Lights (DRL)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'daytime_running_lights',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.electronicStabilityControlESC'}
      defaultMessage={'Electronic Stability Control (ESC)'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'electronic_stability_control',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.headUpDisplay'}
      defaultMessage={'Head-Up Display'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'head_up_display',
    'type': 'bool'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.safety'}
      defaultMessage={'Safety'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.electronicParkBreak'}
      defaultMessage={'Electronic Park Brake'} /></MessageWrapper>,
    'reverse': false,
    'search_show': false,
    'slug': 'electronic_parking_brake',
    'type': 'bool'
  }]
}, {
  'slug': 'leasing',
  'details_open': false,
  'details_show': false,
  'compare_show':false,
  'icon': <ColorLensIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.leasing'}
    defaultMessage={'Leasing'} /></MessageWrapper>,
  'search_open': false, 'compare_open': false,
  'search_show': false,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.leasing'}
      defaultMessage={'Leasing'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.monthlyPrice'}
      defaultMessage={'Monthly Payment'} /></MessageWrapper>,
    'path': 'monthly_amount',
    'reverse': false,
    'search_show': true,
    'slug': 'monthly_amount',
    'step': 500,
    'type': 'float',
    'unit': 'currency'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.leasing'}
      defaultMessage={'Leasing'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.facet.leaseTerm'}
      defaultMessage={'Lease Term'} /></MessageWrapper>,
    'path': 'number_of_months',
    'search_show': true,
    'slug': 'number_of_months',
    'type': 'int',
    'unit': ' Months'
  }]
}, {
  'slug': 'color',
  'details_open': false,
  'details_show': false,
  'icon': <ColorLensIcon />,
  'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.colorOptions'}
    defaultMessage={'Colour Options'} /></MessageWrapper>,
  'search_open': false,
  'compare_open': false,
  'search_show': true,
  'compare_show':true,
  'values': [{
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.extColor'}
      defaultMessage={'Colour Options'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.extColor'}
      defaultMessage={'Exterior Colour'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'exterior_color',
    'type': 'names'
  }, {
    'category': <MessageWrapper><FormattedMessage id={'fieldConfig.group.extColor'}
      defaultMessage={'Colour Options'} /></MessageWrapper>,
    'details_show': true,
    'compare_show': true,
    'name': <MessageWrapper><FormattedMessage id={'fieldConfig.group.intColor'}
      defaultMessage={'Interior Colour'} /></MessageWrapper>,
    'reverse': false,
    'search_show': true,
    'slug': 'interior_color',
    'type': 'names'
  }]
}];

export default FIELD_CONFIG;


export const ALL_FIELDS = FIELD_CONFIG.map(s => s.values).reduce((a, b) => [...a, ...b], []);
export const FIELDS_BY_NAME = {};
ALL_FIELDS.forEach(f => FIELDS_BY_NAME[f.name] = f);

